import React, { useEffect, useState } from 'react';
import FormSection from 'components/sales/formSection/formSection';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';

const PocForm = ({
  handleValue,
  pocById,
  getPocData,
  id,
  siteId,
  noTitle,
  status = [
    { name: 'Active', id: 1 },
    { name: 'In Active', id: 2 },
  ],
}) => {
  const pocInputs = {
    site_id: '',
    name: '',
    designation: '',
    contact_no: '',
    // secondary_contact: "",
    email: '',
    status: '1',
  };
  const editInputs = {
    id: '',
    site_id: '',
    name: '',
    designation: '',
    contact_no: '',
    // secondary_contact: "",
    email: '',
    status: '1',
  };
  const [editVal, setEditVal] = useState(editInputs);
  const [pocData, setPocData] = useState(pocInputs);
  const [isSameContact, setIsSameContact] = useState(false);

  const compareContacts = (primary = '', secondary = '') => {
    if (secondary) {
      if (Number(primary) === Number(secondary)) {
        setIsSameContact(true);
      } else setIsSameContact(false);
    } else setIsSameContact(false);
  };

  const handlePocData = () => {
    if (
      pocData.name !== '' &&
      pocData.designation !== '' &&
      pocData.contact_no !== '' &&
      pocData.email !== '' &&
      pocData.status !== '' &&
      pocData.level !== ''
    ) {
      if (id) {
        handleValue({
          id: pocById.id,
          site_id: siteId,
          name: editVal.name,
          designation: editVal.designation,
          contact_no: editVal.contact_no,
          email: editVal.email,
          level: editVal.level
        });
      } else {
        handleValue({
          ...pocData,
          site_id: siteId,
          name: pocData.name,
          designation: pocData.designation,
          contact_no: pocData.contact_no,
          email: pocData.email,
          status: pocData.status,
          level: pocData.level
        });
      }
    } else {
      handleValue(null);
    }
  };

  useEffect(() => {
    handlePocData();
  }, [pocData]);

  useEffect(() => {
    if (pocById) {
      setEditVal(pocById);
    }
  }, [pocById]);

  useEffect(() => {
    setEditVal(editInputs);
  }, []);

  useEffect(() => {
    if (id) {
      handleValue({
        id: pocById.id,
        site_id: siteId,
        name: editVal.name,
        designation: editVal.designation,
        contact_no: editVal.contact_no,
        email: editVal.email,
        status: editVal.status,
        level: editVal.level
      });
    }
  }, [editVal]);

  return (
    
    <FormSection
      title={
        id
          ? localization.editPocDetail
          : noTitle
          ? ''
          : localization.pocDetailTitle
      }
    >
      <ConstantInput
        value={editVal.name}
        label={localization.POCName}
        regex={Regex.text.test(pocData.name)}
        errorMsg={localization.requiredPocName}
        type="text"
        required
        handleChange={(value) => {
          setPocData({ ...pocData, name: value });
          setEditVal({ ...editVal, name: value });
        }}
        isStarRequired={true}
      />
      <ConstantInput
        value={editVal.designation}
        label={localization.POCDesignation}
        regex={Regex.text.test(pocData.designation)}
        errorMsg={localization.requiredPocDesig}
        type="text"
        required
        handleChange={(value) => {
          setPocData({ ...pocData, designation: value });
          setEditVal({ ...editVal, designation: value });
        }}
        isStarRequired={true}
      />
      <ConstantInput
        value={pocById.id ? `${editVal.contact_no}` : pocData.contact_no}
        label={localization.phoneNumber}
        regex={Regex.phoneNumber.test(pocData.contact_no)}
        errorMsg={localization.phoneError}
        maxLength={10}
        minLength={10}
        type="text"
        isPrefix
        prefixText={'+91'}
        required
        handleChange={(value) => {
          setPocData({ ...pocData, contact_no: value });
          setEditVal({ ...editVal, contact_no: value });
        }}
        isStarRequired={true}
      />
      {/* <ConstantInput
        value={
          pocById.id
            ? `${editVal.secondary_contact}`
            : pocData.secondary_contact
        }
        label={localization.secondContact}
        regex={Regex.phoneNumber.test(pocData.secondary_contact)}
        errorMsg={isSameContact ? localization.numberShouldBeDifferent : null}
        blockError={isSameContact}
        maxLength={10}
        minLength={10}
        isPrefix
        prefixText={"+91"}
        type="text"
        handleChange={(value) => {
          setPocData({ ...pocData, secondary_contact: value });
          setEditVal({ ...editVal, secondary_contact: value });
          compareContacts(
            pocById.id ? editVal.contact_no : pocData.contact_no,
            value
          );
        }}
      /> */}
      <ConstantInput
        value={editVal.email}
        label={localization.emailAddress}
        regex={
          Regex.email.test(pocData.email) || Regex.email.test(editVal.email)
        }
        errorMsg={localization.emailError}
        type="email"
        required
        handleChange={(value) => {
          setPocData({ ...pocData, email: value });
          setEditVal({ ...editVal, email: value });
        }}
        isStarRequired={true}
      />
      {/* <DropDownInput
        disabled={status.length === 0}
        label={localization.status}
        data={status}
        required
        value={editVal.status === 1 ? 'Active' : 'In Active'}
        errorMsg={localization.statusErrorMsg}
        getIdValue={(value) => {
          setPocData({ ...pocData, status: value.id });
          setEditVal({ ...editVal, status: value.id });
        }}
        isStarRequired={true}
      /> */}
      <DropDownInput
            value={editVal.level}
            data={[
                { id: "L1", name: "L1 - Site POC" },
                { id: "L2", name: "L2 - Central POC" },
                { id: "L3", name: "L3 - Top level escalation" }
              ]}
            label="level Level"
            required
            errorMsg={localization.selectlevel}
            getIdValue={(value) => {
              setPocData({ ...pocData, level: value.id });
              setEditVal({ ...editVal, level: value.id });
            }}
            isStarRequired={true}
        />
    </FormSection>
  );
};

export default PocForm;
